import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '../../core/Button';
import DataItem from '../../data/Item';
import DataAction from '../../data/actions';
import FormProvider from './Provider';
import FormError, { FORM_ERROR } from '../Error';
import AutoSave from './AutoSave';
import { withTheme } from '@material-ui/core/styles';
import deepEqual from '../../utils/deepEqual';
import FormKeys from './Keys';
import placeholders from '../../data/placeholders';
import Page from '../../page';
var DEFAULT_VALUE = {};
export var FormFragmentContext = React.createContext(DEFAULT_VALUE);
/**
 * @extends {React.Component<import('./types').FormFragmentProps>}
 */

var FormFragment =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormFragment, _React$Component);

  function FormFragment() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormFragment);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormFragment)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onCancel = function () {
      return _this.props.onCancel();
    };

    _this.onSubmit =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data) {
        var _this$props, dataItemProps, confirmSubmit, confirmed, successResponse, dataType;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, dataItemProps = _this$props.dataItemProps, confirmSubmit = _this$props.confirmSubmit;

                if (!confirmSubmit) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return confirmSubmit(data);

              case 4:
                confirmed = _context.sent;

                if (!(confirmed === false)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                if (dataItemProps) {
                  _context.next = 14;
                  break;
                }

                successResponse = _this.props.onSuccess(data);

                if (successResponse) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                if (!successResponse.then) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", successResponse.then(function (action) {
                  if (action && action.payload && action.payload.error) {
                    return _defineProperty({}, FORM_ERROR, action.payload.text);
                  }

                  return action;
                }, function (error) {
                  if (error && error.message) {
                    return _defineProperty({}, FORM_ERROR, error.message);
                  }
                }));

              case 13:
                return _context.abrupt("return");

              case 14:
                dataType = dataItemProps.dataType;
                return _context.abrupt("return", DataAction.item(dataItemProps).save(data).then(function (action) {
                  if (action.payload && action.payload.error) {
                    return _defineProperty({}, FORM_ERROR, action.payload.text);
                  } //refresh all data grids


                  DataAction.grid({
                    dataType: dataType
                  }).refresh(); //notify

                  if (_this.props.onSuccess) _this.props.onSuccess(data, action.payload);
                  return {};
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.getInitialValues = function (data) {
      var _this$props2 = _this.props,
          dataItemProps = _this$props2.dataItemProps,
          defaultValue = _this$props2.defaultValue;
      var initialValues = {};

      if (dataItemProps && data) {
        if (data.value) {
          if (defaultValue) {
            initialValues = _objectSpread({}, defaultValue, data.value);
          } else {
            initialValues = data.value;
          }
        } else {
          initialValues = defaultValue;
        }
      } else {
        if (defaultValue) initialValues = defaultValue;
      }

      return initialValues;
    };

    _this.renderFooter = function (argument) {
      var handleSubmit = argument.handleSubmit,
          submitting = argument.submitting,
          hasValidationErrors = argument.hasValidationErrors;
      var _this$props3 = _this.props,
          dataItemProps = _this$props3.dataItemProps,
          hideCancelButton = _this$props3.hideCancelButton,
          hideSubmitButton = _this$props3.hideSubmitButton,
          color = _this$props3.color,
          submitLabel = _this$props3.submitLabel,
          submittingLabel = _this$props3.submittingLabel,
          submitAlign = _this$props3.submitAlign,
          disableSubmit = _this$props3.disableSubmit,
          disabled = _this$props3.disabled;
      var submitLabelText = 'Submit';
      var submittingLabelText = 'Submitting...';

      if (dataItemProps) {
        if (dataItemProps.id) {
          submitLabelText = 'Save';
          submittingLabelText = 'Saving...';
        } else {
          submitLabelText = 'Create';
          submittingLabelText = 'Creating...';
        }
      }

      if (submitLabel) submitLabelText = submitLabel;
      if (submittingLabel) submittingLabelText = submittingLabel;
      return React.createElement("div", null, React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center"
      }, _this.props.renderFooterLeft && React.createElement(Grid, Object.assign({
        item: true
      }, submitAlign !== 'left' && {
        xs: true
      }), React.createElement("div", {
        style: {
          marginRight: 8
        }
      }, _this.props.renderFooterLeft(argument))), submitAlign !== 'left' && !_this.props.renderFooterLeft && React.createElement(Grid, {
        item: true,
        xs: true
      }), !hideCancelButton && React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        color: "default",
        variant: "outlined",
        onClick: _this.onCancel,
        disabled: submitting || disableSubmit,
        "aria-label": "Cancel",
        style: {
          marginRight: 8
        }
      }, "Cancel")), !hideSubmitButton && !_this.props.autoSubmit && React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "contained",
        color: color,
        onClick: handleSubmit,
        pendingPromise: submittingLabelText,
        disabled: disabled || submitting || disableSubmit || hasValidationErrors
      }, submitLabelText)), submitAlign !== 'right' && React.createElement(Grid, {
        item: true,
        xs: true
      })));
    };

    _this.renderContent = function (argument) {
      // @ts-ignore
      var submitError = argument.submitError,
          submitting = argument.submitting,
          dirty = argument.dirty,
          dirtySinceLastSubmit = argument.dirtySinceLastSubmit;
      var style = _this.props.style;
      /**@type {import('react').CSSProperties} */

      var containerStyles = _objectSpread({
        padding: 16,
        pointerEvents: submitting ? 'none' : 'auto'
      }, style);

      return React.createElement(React.Fragment, null, submitError && !submitting && !dirtySinceLastSubmit && React.createElement(FormError, {
        sticky: true
      }, submitError), React.createElement("div", {
        style: containerStyles
      }, _this.props.children, _this.props.renderContent && _this.props.renderContent(argument)));
    };

    _this.renderChildren = function (formData) {
      var _this$props4 = _this.props,
          renderer = _this$props4.renderer,
          keys = _this$props4.keys;
      var autoSave = null;
      if (_this.props.autoSubmit) autoSave = React.createElement(AutoSave, {
        save: formData.handleSubmit
      });
      var FormContainer = React.Fragment;
      var formContainerProps = {};

      if (keys) {
        // @ts-ignore
        FormContainer = FormKeys;
        formContainerProps = {
          onSubmit: formData.handleSubmit
        };
      }

      ;

      if (renderer) {
        return React.createElement(FormContainer, formContainerProps, autoSave, renderer(formData, _this.renderContent, _this.renderFooter));
      }

      return React.createElement("div", {
        style: {
          marginBottom: 8 * 2
        }
      }, React.createElement(FormContainer, formContainerProps, autoSave, _this.renderContent(formData), _this.renderFooter(formData)));
    };

    _this.renderProvider = function (data) {
      // @ts-ignore
      var _this$props5 = _this.props,
          theme = _this$props5.theme,
          variant = _this$props5.variant,
          color = _this$props5.color,
          disabled = _this$props5.disabled,
          labelPlacement = _this$props5.labelPlacement,
          labelVariant = _this$props5.labelVariant,
          subscription = _this$props5.subscription;
      var themeProps = theme.getProps('Form.Fragment');

      var context = _objectSpread({}, themeProps);

      if (variant) context.variant = variant;
      if (color) context.color = color;
      if (disabled) context.disabled = disabled;
      if (labelPlacement) context.labelPlacement = labelPlacement;
      if (labelVariant) context.labelVariant = labelVariant;
      context.loading = data && data.loading;
      if (data && data.error) return React.createElement(FormFragmentDataItemError, {
        error: data.error,
        formProps: _this.props
      });
      return React.createElement(FormFragmentContext.Provider, {
        value: context
      }, React.createElement(FormProvider, {
        context: context,
        subscription: subscription,
        initialValues: _this.getInitialValues(data),
        initialValuesEqual: deepEqual,
        render: _this.renderChildren,
        validate: _this.props.onValidate,
        onSubmit: _this.onSubmit
      }));
    };

    return _this;
  }

  _createClass(FormFragment, [{
    key: "render",
    value: function render() {
      var dataItemProps = this.props.dataItemProps;
      if (!dataItemProps) return this.renderProvider();
      return React.createElement(DataItem, dataItemProps, this.renderProvider);
    }
  }]);

  return FormFragment;
}(React.Component);
/**
 * @param {import('./types').FormFragmentDataItemErrorProps} props
 */


var FormFragmentDataItemError = function FormFragmentDataItemError(_ref5) {
  var error = _ref5.error,
      formProps = _ref5.formProps;
  if (!formProps.dataItemProps) return null;
  var props = {
    error: error,
    text: error.text,
    status: error.status
  };
  props.dataTypeLabel = placeholders('{type}', formProps.dataItemProps);
  if (formProps.renderError) return formProps.renderError(props);
  if (error.status === 404) return React.createElement(FormError, null, "".concat(props.status, " - ").concat(props.text));else return React.createElement(Page.Error, {
    hideNavBar: true,
    message: "".concat(props.status, " - ").concat(props.text)
  });
};
/**
 * @type {Partial<import('./types').FormFragmentProps>}
 */


FormFragment.defaultProps = {
  hideCancelButton: true,
  hideSubmitButton: false,
  submitAlign: 'center',
  color: 'primary',
  disableSubmit: false,
  disabled: false,
  keys: false
};
export default withTheme(FormFragment);